import {
  LayoutDashboard,
  Building2,
  Users,
  Truck,
  Package,
  FileText,
  Banknote,
  Wallet,
  Receipt,
  BarChart3,
  CalendarClock,
  IdCard,
  Settings,
} from 'lucide-react'
import type { Permission } from '@/lib/permissions'

export interface SidebarItem {
  href: string
  label: string
  icon: React.ElementType
  // exibe o item se o usuario tiver QUALQUER uma destas permissoes
  permissions: readonly Permission[]
}

export interface SidebarGroup {
  id: string
  label: string
  items: readonly SidebarItem[]
}

export const SIDEBAR_GROUPS: readonly SidebarGroup[] = [
  {
    id: 'operation',
    label: 'Operação',
    items: [
      {
        href: '/dashboard',
        label: 'Dashboard',
        icon: LayoutDashboard,
        permissions: ['freight.read', 'invoice.read', 'cash.read'],
      },
      {
        href: '/freights',
        label: 'Fretes',
        icon: Package,
        permissions: ['freight.read'],
      },
    ],
  },
  {
    id: 'records',
    label: 'Cadastros',
    items: [
      {
        href: '/companies',
        label: 'Empresas',
        icon: Building2,
        permissions: ['company.read'],
      },
      {
        href: '/drivers',
        label: 'Motoristas',
        icon: Users,
        permissions: ['driver.read'],
      },
      {
        href: '/vehicles',
        label: 'Veículos',
        icon: Truck,
        permissions: ['vehicle.read'],
      },
    ],
  },
  {
    id: 'finance',
    label: 'Financeiro',
    items: [
      {
        href: '/invoices',
        label: 'Faturas',
        icon: FileText,
        permissions: ['invoice.read'],
      },
      {
        href: '/repayments',
        label: 'Repasses',
        icon: Banknote,
        permissions: ['repayment.read'],
      },
      {
        href: '/financial-obligations',
        label: 'A pagar/receber',
        icon: CalendarClock,
        permissions: ['obligation.read'],
      },
      {
        href: '/cash',
        label: 'Fluxo de Caixa',
        icon: Wallet,
        permissions: ['cash.read'],
      },
      {
        href: '/operational-expenses',
        label: 'Despesas',
        icon: Receipt,
        permissions: ['expense.read'],
      },
    ],
  },
  {
    id: 'management',
    label: 'Gestão',
    items: [
      {
        href: '/employees',
        label: 'Funcionários',
        icon: IdCard,
        permissions: ['employee.read'],
      },
      {
        href: '/reports',
        label: 'Relatórios',
        icon: BarChart3,
        permissions: ['reports.view'],
      },
    ],
  },
  {
    id: 'admin',
    label: 'Administração',
    items: [
      {
        href: '/settings',
        label: 'Configurações',
        icon: Settings,
        permissions: [
          'settings.appearance',
          'team.read',
          'settings.view_audit',
          'team.manage_roles',
        ],
      },
    ],
  },
]
